import { render, staticRenderFns } from "./MDArticle.vue?vue&type=template&id=3217bee8&lang=pug"
import script from "./MDArticle.vue?vue&type=script&lang=js"
export * from "./MDArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports